export const crashGames = {
  AviatorX2: {
    href: "/casino/aggapmac88gamingvirtual-aviatorx2",
    code: "",
    casino: "Mac88 Gaming Virtual",
    provider: "ALT_GAMING_GAP",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/crash-games/AviatorX2.webp",
    alt: "AviatorX2",
    name: "AviatorX2",
  },
  Baloon: {
    href: "/casino/aggapsmartsoftgaming-baloon",
    code: "",
    casino: "Smartsoft Gaming",
    provider: "ALT_GAMING_GAP",
    gameType: "crash",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/crash-games/Baloon.webp",
    alt: "Baloon",
    name: "Baloon",
  },
  Cappadocia: {
    href: "/casino/aggapsmartsoftgaming-cappadocia",
    code: "",
    gameType: "crash",
    casino: "Smartsoft Gaming",
    provider: "ALT_GAMING_GAP",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/crash-games/Cappadocia.webp",
    alt: "Cappadocia",
    name: "Cappadocia",
  },
  CoinWinHoldTheSpin: {
    href: "/casino/aggapgamzix-coin-win-hold-the-spin",
    code: "",
    gameType: "crash",
    casino: "Gamzix",
    provider: "ALT_GAMING_GAP",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/crash-games/CoinWinHoldTheSpin.webp",
    alt: "Coin Win: Hold The Spin",
    name: "Coin Win: Hold The Spin",
  },
  CrashX: {
    href: "/casino/aggapturbogames-crash-x",
    code: "",
    gameType: "crash",
    casino: "Turbo Games",
    provider: "ALT_GAMING_GAP",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/crash-games/CrashX.webp",
    alt: "CrashX",
    name: "CrashX",
  },
  CricketX: {
    href: "/casino/aggapsmartsoftgaming-cricketx",
    code: "",
    gameType: "crash",
    casino: "Smartsoft Gaming",
    provider: "ALT_GAMING_GAP",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/crash-games/CricketX.webp",
    alt: "CricketX",
    name: "CricketX",
  },
  FirstPersonSuperSicBo: {
    href: "/casino/aggapevolutiongaming-first-person-super-sic-bo",
    code: "",
    gameType: "crash",
    casino: "Evolution Gaming",
    provider: "ALT_GAMING_GAP",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/crash-games/FirstPersonSuperSicBo.webp",
    alt: "First Person Super Sic Bo",
    name: "First Person Super Sic Bo",
  },
  FootballX: {
    href: "/casino/aggapsmartsoftgaming-footballx",
    code: "",
    gameType: "crash",
    casino: "Smartsoft Gaming",
    provider: "ALT_GAMING_GAP",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/crash-games/FootballX.webp",
    alt: "FootballX",
    name: "FootballX",
  },
  JetX: {
    href: "/casino/aggapsmartsoftgaming-jetx",
    code: "",
    gameType: "crash",
    casino: "Smartsoft Gaming",
    provider: "ALT_GAMING_GAP",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/crash-games/JetX.webp",
    alt: "JetX",
    name: "JetX",
  },
  JetX3: {
    href: "/casino/aggapsmartsoftgaming-jetx3",
    code: "",
    gameType: "crash",
    casino: "Smartsoft Gaming",
    provider: "ALT_GAMING_GAP",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/crash-games/JetX3.webp",
    alt: "JetX3",
    name: "JetX3",
  },
  JetXt: {
    href: "/casino/aggapcrash88gaming-jetxt",
    code: "",
    gameType: "crash",
    casino: "CRASH88 Gaming",
    provider: "ALT_GAMING_GAP",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/crash-games/jetxt.webp",
    alt: "JetXt",
    name: "JetXt",
  },
  Kitex: {
    href: "/casino/aggapmac88gamingvirtual-kitex",
    code: "",
    gameType: "crash",
    casino: "Mac88 Gaming Virtual",
    provider: "ALT_GAMING_GAP",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/crash-games/Kitex.webp",
    alt: "Kitex",
    name: "Kitex",
  },
  OlympusofLuckHoldTheSpin: {
    href: "/casino/aggapgamzix-olympus-of-luck-hold-the-spin",
    code: "",
    gameType: "crash",
    casino: "Gamzix",
    provider: "ALT_GAMING_GAP",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/crash-games/OlympusofLuckHoldTheSpin.webp",
    alt: "Olympus of Luck: Hold The Spin",
    name: "Olympus of Luck: Hold The Spin",
  },
  PushpaRani: {
    href: "/casino/aggapmac88gamingvirtual-pushpa-rani",
    code: "",
    gameType: "crash",
    casino: "Mac88 Gaming Virtual",
    provider: "ALT_GAMING_GAP",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/crash-games/PushpaRani.webp",
    alt: "Pushpa Rani",
    name: "Pushpa Rani",
  },
  SlicerX: {
    href: "/casino/aggapsmartsoftgaming-slicerx",
    code: "",
    gameType: "crash",
    casino: "Mac88 Gaming Virtual",
    provider: "ALT_GAMING_GAP",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/crash-games/SlicerX.webp",
    alt: "SlicerX",
    name: "SlicerX",
  },
  TowerX: {
    href: "/casino/aggapsmartsoftgaming-towerx",
    code: "",
    gameType: "crash",
    casino: "Smartsoft Gaming",
    provider: "ALT_GAMING_GAP",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/crash-games/TowerX.webp",
    alt: "TowerX",
    name: "TowerX",
  },
};
